import { createApi } from '@reduxjs/toolkit/query/react';

import { createBaseQuery } from './createBaseQuery';

interface ViewedImage {
  userId: string;
  pictureUrl: string;
  batchIndex: number;
  dialogId: string;
  scenarioId: string;
  configId: string;
  visitorId: string;
  t: number;
  id: string;
  timestamp: number;
  createdTimestamp: number;
  updatedTimestamp: number;
}

export const storageApi = createApi({
  reducerPath: 'storageApi',
  baseQuery: createBaseQuery(),
  endpoints: (builder) => ({
    getViewedImages: builder.query<ViewedImage[], void>({
      query: () => ({
        url: '/my-viewed-images',
        method: 'GET',
      }),
      transformResponse: (response: ViewedImage[]) => {
        return response?.sort((a, b) => a.timestamp - b.timestamp);
      },
    }),
  }),
});

export const { useGetViewedImagesQuery } = storageApi; 